package pl.mothdigital.neuronowi.pages.therapies.terapiaSluchowa

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobweb.silk.components.icons.fa.*
import pl.mothdigital.neuronowi.common.model.*
import pl.mothdigital.neuronowi.components.layouts.*

@Page
@Composable
fun TherapyAuditoryPage() {
    TherapyPageLayout(
        content = TherapyPageContent(
            title = "Terapia słuchowa",
            icon = { FaEarDeaf() },
            description = "Diagnoza i terapia centralnych zaburzeń przetwarzania słuchowego, które wpływają na komunikację i uczenie się.",
            sections = listOf(
                TherapySection(
                    title = "Czym jest terapia słuchowa?",
                    content = """
                        Terapia słuchowa to specjalistyczne podejście terapeutyczne skupiające się na poprawie
                        funkcjonowania centralnego układu słuchowego. Koncentruje się na usprawnianiu procesów
                        przetwarzania informacji słuchowych w mózgu, co ma kluczowe znaczenie dla rozwoju mowy,
                        komunikacji oraz umiejętności uczenia się.
                    """.trimIndent()
                ),
                TherapySection(
                    title = "Dla kogo jest terapia słuchowa?",
                    content = """
                        Terapia słuchowa jest szczególnie pomocna dla dzieci i dorosłych z:

                        • Centralnymi zaburzeniami przetwarzania słuchowego (CAPD)
                        • Trudnościami w rozróżnianiu dźwięków mowy
                        • Problemami z koncentracją na dźwiękach w hałasie
                        • Opóźnieniami rozwoju mowy i języka
                        • Trudnościami w nauce czytania i pisania
                        • Zaburzeniami ze spektrum autyzmu
                        • ADHD z problemami słuchowymi
                        • Trudnościami w przetwarzaniu sekwencji słuchowych
                        • Problemami z pamięcią słuchową
                    """.trimIndent()
                ),
                TherapySection(
                    title = "Jakie korzyści przynosi terapia słuchowa?",
                    content = """
                        Prawidłowo prowadzona terapia słuchowa może przynieść wiele korzyści:

                        • Poprawę różnicowania dźwięków mowy
                        • Lepsze słyszenie w hałasie
                        • Zwiększenie uwagi słuchowej
                        • Poprawę pamięci słuchowej
                        • Lepsze przetwarzanie sekwencji dźwięków
                        • Wsparcie rozwoju mowy i języka
                        • Poprawę umiejętności czytania
                        • Zwiększenie koncentracji
                        • Lepsze funkcjonowanie w środowisku akustycznym
                    """.trimIndent()
                ),
                TherapySection(
                    title = "Jak przebiega terapia?",
                    content = """
                        Proces terapii słuchowej w Centrum Terapii NeuroNowi obejmuje:

                        1. Szczegółową diagnozę procesów słuchowych - ocenę różnych aspektów przetwarzania
                           słuchowego z wykorzystaniem specjalistycznych testów.

                        2. Opracowanie indywidualnego programu terapeutycznego dostosowanego do profilu
                           zaburzeń słuchowych pacjenta.

                        3. Regularne sesje terapeutyczne z wykorzystaniem specjalistycznego sprzętu
                           i programów komputerowych do treningu słuchowego.

                        4. Trening domowy - instruktaż dla rodziców/opiekunów dotyczący kontynuowania
                           ćwiczeń słuchowych w domu.

                        5. Współpracę z logopedami i innymi terapeutami w celu zapewnienia kompleksowego
                           wsparcia rozwoju komunikacji.
                    """.trimIndent()
                ),
                TherapySection(
                    title = "Nasze metody",
                    content = """
                        W terapii słuchowej stosujemy różnorodne techniki i programy:

                        • Metodę Johansena (JIAS) - trening słuchowy z muzyką
                        • Programy komputerowe do treningu słuchowego
                        • Ćwiczenia różnicowania dźwięków mowy
                        • Trening słyszenia w hałasie
                        • Ćwiczenia pamięci słuchowej
                        • Trening percepcji prozodii (melodii mowy)
                        • Ćwiczenia lokalizacji przestrzennej dźwięków
                        • Integrację terapii słuchowej z logopedią
                    """.trimIndent()
                ),
                TherapySection(
                    title = "Nasi specjaliści",
                    content = """
                        Terapię słuchową w naszym centrum prowadzą specjaliści z przygotowaniem w zakresie
                        audiologii, terapii słuchowej i neurorehabilitacji. Nasi terapeuci posiadają certyfikaty
                        w zakresie różnych metod terapii słuchowej, w tym metody Johansena, i regularnie uczestniczą
                        w szkoleniach, aby zapewnić pacjentom dostęp do najnowocześniejszych technik terapeutycznych
                        w obszarze przetwarzania słuchowego.
                    """.trimIndent()
                )
            )
        )
    )
}
